import React from "react";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { timeAgo } from "@/lib/format";
import {
  Plus, CalendarClock, CheckCircle2, FileText, IndianRupee, Store,
  UserPlus, RefreshCw, Activity,
} from "lucide-react";

const ICONS = {
  created_lead: { icon: Plus, cls: "bg-brand/10 text-brand" },
  updated_lead: { icon: RefreshCw, cls: "bg-secondary text-secondary-foreground" },
  followup: { icon: CalendarClock, cls: "bg-status-followup/10 text-status-followup" },
  deal_done: { icon: CheckCircle2, cls: "bg-status-dealdone/10 text-status-dealdone" },
  status_change: { icon: RefreshCw, cls: "bg-status-negotiation/10 text-status-negotiation" },
  deal_processing: { icon: FileText, cls: "bg-accent text-accent-foreground" },
  created_dealership: { icon: Store, cls: "bg-secondary text-secondary-foreground" },
  created_employee: { icon: UserPlus, cls: "bg-accent text-accent-foreground" },
  payment: { icon: IndianRupee, cls: "bg-status-dealdone/10 text-status-dealdone" },
};

export const ActivityItem = ({ activity, showActor = false }) => {
  const navigate = useNavigate();
  const meta = ICONS[activity.action_type] || { icon: Activity, cls: "bg-secondary text-secondary-foreground" };
  const Icon = meta.icon;
  const clickable = Boolean(activity.lead_id);
  return (
    <div
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onClick={() => clickable && navigate(`/leads/${activity.lead_id}`)}
      onKeyDown={(e) => clickable && e.key === "Enter" && navigate(`/leads/${activity.lead_id}`)}
      className={cn(
        "flex items-start gap-3 border-b border-border px-4 py-3 last:border-0",
        clickable && "cursor-pointer transition-colors hover:bg-secondary/50"
      )}
    >
      <span className={cn("mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg", meta.cls)}>
        <Icon className="h-4 w-4" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm text-foreground">{activity.description}</p>
        <p className="mt-0.5 text-[11px] text-muted-foreground">{timeAgo(activity.created_at)}</p>
      </div>
    </div>
  );
};
